import { useMemo } from 'react';

// Chunks a flat recipe list into rows of `columns`. Both virtualized recipe
// grids measure and recycle whole rows rather than individual cards, so the
// grid stays a grid while only the visible rows exist in the DOM.
export function useRecipeRows(recipes, columns) {
  return useMemo(() => {
    const result = [];
    for (let i = 0; i < recipes.length; i += columns) {
      result.push(recipes.slice(i, i + columns));
    }
    return result;
  }, [recipes, columns]);
}
